/**
 * Aspect — runtime service endpoints
 * --------------------------------------------------------------
 * Dev: bridge :8080, orchestrator :3000.
 * Prod (same-origin gateway): use the page host so one HTTPS/WSS deploy works
 * without baking a hostname into the Vite build.
 */

function env(name) {
  const v = import.meta.env?.[name];
  return typeof v === "string" && v.trim() ? v.trim() : "";
}

/** HTTP base URL for the orchestrator (no trailing slash). */
export function orchUrl() {
  const fromEnv = env("VITE_ORCH_URL");
  if (fromEnv) return fromEnv.replace(/\/$/, "");
  if (import.meta.env.DEV) return "http://127.0.0.1:3000";
  if (typeof location !== "undefined") return location.origin;
  return "http://127.0.0.1:3000";
}

/** WebSocket URL for the scene bridge. */
export function bridgeUrl() {
  const fromEnv = env("VITE_BRIDGE_URL");
  if (fromEnv) return fromEnv;
  if (import.meta.env.DEV) return "ws://127.0.0.1:8080";
  if (typeof location === "undefined") return "ws://127.0.0.1:8080";
  const proto = location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${location.host}`;
}

/** @deprecated Prefer orchUrl() — kept for existing imports. */
export const ORCH_URL = orchUrl();
